<template>
  <div style="margin-bottom: 20px">
    <div v-if="evidences && evidences.length > 0" style="margin-bottom: 20px">
      <h4 class="text-left"><slot name="title" /></h4>
      <div
        v-for="(eviFile, index) of evidences"
        :key="index"
        style="margin-bottom: 5px"
      >
        <span v-if="eviFile.title != 'null'"
          ><b>{{ eviFile.title }}</b></span
        >
        <span v-else>
          <b> - </b>
        </span>
        <span v-if="eviFile.name && eviFile.evidenceType === 'file'"
          >(<a
            style="color: blue; cursor: pointer"
            @click="downloadFile(eviFile._id, eviFile.name)"
            >{{ eviFile.name }}</a
          >)</span
        >
        <span v-if="canDelete">
          <b-button
            size="sm"
            variant="link"
            class="mr-1"
            @click="openDeleteModal(eviFile)"
          >
            <img
              src="../../assets/images/delete_icon.svg"
              style="width: 20px; height: 20px"
            />
          </b-button>
        </span>
        <span v-if="eviFile.name && eviFile.evidenceType === 'url'"
          >(<a target="_blank" :href="getLink(eviFile.name)">{{
            eviFile.name
          }}</a
          >)</span
        >
        <div v-if="eviFile.description === 'null'"> - </div>
        <div v-else>{{ eviFile.requirements.description || eviFile.description }}</div>
      </div>
    </div>
    <div
      v-if="
        requirement && requirement.evidences && requirement.evidences.comments
      "
    >
      <h4 style="margin-top: 10px">
        {{
          $t(
            "label_evaluation_evidencesRequested_evidenceNotAvailable_subtitle"
          )
        }}
      </h4>
      <div
        v-for="(eviComment, eviCommentIndex) of requirement.evidences.comments"
        :key="eviCommentIndex"
      >
        <span v-if="eviComment.account && eviComment.account.account"
          >{{ eviComment.account.account.name }}
          {{ eviComment.account.account.lastName }}</span
        >
        <span v-if="eviComment.date">({{ eviComment.date }}): </span>
        <span>{{ eviComment.comment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TemplateUploadedFiles",
  props: ["requirement", "evaluationId", "canDelete", "evidences"],

  data() {
    return {
    };
  },
  methods: {
    getLink(link) {
      let hasHttp = link.includes("http://") || link.includes("https://");
      return hasHttp ? link : `https://${link}`;
    },
    encodeName(name) {
      return encodeURIComponent(name);
    },
    downloadFile: async function (id, fileName) {
      await axios
        .get(`/Evidences/downloadEvidence/${id}/${fileName}`)
        .then((response) => {
          const link = document.createElement("a");
          link.setAttribute("style", "display: none");
          link.href = response.data;
          link.download = fileName;
          link.target = "_blank";
          //document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    openDeleteModal(evidence) {
      this.$emit("openDeleteModal", evidence);
    },
  },
};
</script>

<style lang="sass" scoped>
/* components/template/_template-uploaded-files.vue */
</style>
